export default {
	styleOverrides: {
		root: ({ theme }) => ({
			'.MuiDataGrid-row': {
				'&:hover, &.Mui-hovered': {
					backgroundColor: 'rgba(41, 86, 158, 0.08)',
				},
				'&:nth-of-type(odd)': {
					backgroundColor: theme.palette.background.eveCustom.secondary,
					'&:hover, &.Mui-hovered': {
						backgroundColor: 'rgba(41, 86, 158, 0.08)',
					},
				},
			},
			'.MuiDataGrid-columnHeaders': {
				// TODO Remove this background styling once all projects are migrated to @mui/x-data-grid@7
				// Background styling will be handled in src/components/themes/mixins/mui-x/DataGrid.js
				backgroundColor: theme.palette.primary.dark,
				color: theme.palette.primary.contrastText,
				'.MuiDataGrid-iconSeparator': {
					color: theme.palette.primary.contrastText,
				},
				// Hide the icon separator that is rendered after the rightmost header cell
				'.MuiDataGrid-columnHeader:last-child .MuiDataGrid-iconSeparator': {
					display: 'none',
				},
			},
			'.MuiDataGrid-menuIconButton': {
				color: theme.palette.primary.contrastText,
			},
			'.MuiDataGrid-sortIcon': {
				color: theme.palette.primary.contrastText,
			},
		}),
	},
};
